import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PermissionEnum } from '@models';
import { LoginRedirectService, PermissionService } from 'src/app/services';

export function resourceGuard(...permissions: PermissionEnum[]): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const loginRedirectService = inject(LoginRedirectService);
    if (!permissionService.permissions()) {
      return true;
    }
    const hasPermission = permissionService.hasPermission(permissions);
    if (!hasPermission) {
      loginRedirectService.logout();
    }
    return hasPermission;
  };
}
